import { c as _c } from "react/compiler-runtime";
import { MdScanner } from "react-icons/md";
const DOWNLOAD_URL = "https://decoda-health.github.io/scanner-bridge/download.html";
const SETUP_GUIDE_URL = "https://docs.decodahealth.com/guides/scanner-bridge";
export default function ScannerDownloadBanner() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MdScanner className="h-5 w-5 flex-shrink-0 text-foreground-secondary" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className="font-medium text-link hover:text-link-hover">Download Scanner Bridge</a>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-3 rounded-lg border border-border bg-background-secondary px-4 py-3">{t0}<div className="flex-1 text-body text-foreground-secondary">Want to scan documents directly?{" "}{t1}{" "}for your computer.{" "}<a href={SETUP_GUIDE_URL} target="_blank" rel="noopener noreferrer" className="text-foreground-tertiary hover:text-foreground-secondary">Setup guide →</a></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}